import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const cursorSpring = { damping: 20, stiffness: 200, mass: 0.5 };
const dotSpring = { damping: 40, stiffness: 800, mass: 0.2 };
const cursorIdleDelay = 150;

export function CustomCursor() {
  const isVisible =
    typeof window === "undefined" ||
    window.matchMedia("(pointer: fine)").matches;

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const [isMoving, setIsMoving] = useState(false);
  const cursorX = useSpring(mouseX, cursorSpring);
  const cursorY = useSpring(mouseY, cursorSpring);
  const dotX = useSpring(mouseX, dotSpring);
  const dotY = useSpring(mouseY, dotSpring);

  useEffect(() => {
    if (!isVisible) return;
    let idleTimer: number | undefined;
    const handleMouseMove = (e: MouseEvent) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
      setIsMoving(true);
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(() => setIsMoving(false), cursorIdleDelay);
    };
    window.addEventListener("mousemove", handleMouseMove);
    document.body.style.cursor = "none";
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.clearTimeout(idleTimer);
      document.body.style.cursor = "";
    };
  }, [isVisible, mouseX, mouseY]);

  if (!isVisible) return null;
  return (
    <>
      <motion.div
        className={`fixed top-0 left-0 border border-white rounded-full pointer-events-none z-[9999] mix-blend-difference -translate-x-1/2 -translate-y-1/2 transition-[width,height] duration-300 ease-out ${isMoving ? "w-8 h-8" : "w-12 h-12"}`}
        style={{ x: cursorX, y: cursorY }}
        aria-hidden="true"
      />
      <motion.div
        className="fixed top-0 left-0 w-1 h-1 bg-white rounded-full pointer-events-none z-[9999] mix-blend-difference -translate-x-1/2 -translate-y-1/2"
        style={{ x: dotX, y: dotY }}
        aria-hidden="true"
      />
    </>
  );
}
